//
// Action types
//

import { isEqual } from "lodash";

export const UPDATE_FIELD_SCHEMA = "UPDATE_FIELD_SCHEMA";

//
// Action creators
//

export function updateFieldSchema(formKey, key, value) {
  return {
    type: UPDATE_FIELD_SCHEMA,
    formKey,
    key,
    value
  };
}

//
// Reducer and handlers
//

function updateFieldSchemaHandler(state, key, value) {
  // Avoid update loop as the schema of each field is quite complex, and without this
  // guard, schema is continuously updated.
  if (isEqual(state[key], value)) return state;

  return { ...state, [key]: value };
}

export function reduceSchema(state = {}, action) {
  switch (action && action.type) {
    case UPDATE_FIELD_SCHEMA:
      return updateFieldSchemaHandler(state, action.key, action.value);

    default:
      return state || {};
  }
}
